import { render, staticRenderFns } from "./AboutLayout.vue?vue&type=template&id=2013d854&"
import script from "./AboutLayout.vue?vue&type=script&lang=js&"
export * from "./AboutLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2013d854')) {
      api.createRecord('2013d854', component.options)
    } else {
      api.reload('2013d854', component.options)
    }
    module.hot.accept("./AboutLayout.vue?vue&type=template&id=2013d854&", function () {
      api.rerender('2013d854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/AboutLayout.vue"
export default component.exports